// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"392":"4cc09c70","420":"cfbfe585","497":"d1d2b3a1"}[chunkId] + ".chunk.css";
};